if($(".js-produkt_list").length != 0){

    htmlRoot = $(".js-produkt_list").data("root");
    var listItemAjax = htmlRoot + 'cmshx_template/ajax/ecprod_get.php';
    var listLimitAjax =  htmlRoot + 'cmshx_template/ajax/set_list_limiter.php';

    $produktList = newWkoList();
    $produktList.setListLimit(parseInt($(".js-produkt_list").data("limit")));
    $produktList.setListLimitAjax(listLimitAjax);
    $produktList.setListItemIds(listItemIds);
    $produktList.setListItemAjax(listItemAjax);
    $produktList.setCurrentPage(parseInt($(".js-produkt_list").data("page")));
    $produktList.addToAjax(parseInt($(".js-produkt_list").data("menu")));
    $produktList.setPagerElement($(".js-list_pager_pages"));
    $produktList.setPagerPagesElement($("<a class='produkt_list_pager_pages_item'></a>"));
    $produktList.setPageLimiter($(".js-list_limiter"));
    $produktList.setAmountWithPageElement($(".js-list_amount_with_page"));
    $produktList.setAmountWithOutPageElement($(".js-list_amount_without_page"));
    $produktList.setKatetorieClass("js-list_kat");
    $produktList.setKatetorieContent(htmlKat);
    if($(".js-list_ges").length > 0) $produktList.setGesCon($(".js-list_ges"));
    if($(".js-list_from").length > 0) $produktList.setFromCon($(".js-list_from"));
    if($(".js-list_to").length > 0) $produktList.setToCon($(".js-list_to"));
    $produktList.init($(".js-produkt_list"));
}

$(document).on('click',".js-share_icon", function(e){
  //copy link in clipboard
    e.preventDefault();
    let $temp = $("<input>");
    $("body").append($temp);
    $temp.val($(this).data('share_url')).trigger('select');
    document.execCommand("copy");
    $temp.remove();

    let icon = "<i class='produkt_list_share_icon fas fa-link'></i>"
    $(this).html(icon + ' ' + copy_msg);

})

